import gql from 'graphql-tag';

export default gql`
    query GetUserRegionDistrictByUserId($userId: Int) {
        getUserRegionDistrictByUserId(userId: $userId) {
            districtIds
            regionIds
        }
    }
`;
